import { getTechnologyIndex } from '@/api'

const state = {
	researchInfo: {},
	researchNav: [],
	searchVal: ''
}

const getters = {
	getSearchval(state) {
		return state.searchVal
	}
}
const mutations = {
	SAVE_RESEARCH(state, data) {
		state.researchInfo = data;
		state.researchNav = data.nav;
	},
	SEARCH(state, data) {
		state.searchVal = data
	}

}
const actions = {
	async getResearch({ commit }) {
		let res = await getTechnologyIndex()
		if (!res.code) {
			commit('SAVE_RESEARCH', res.data)
		} else {
			alert(res.message)
		}
	},
	seachFn({ commit }, data) {
		commit('SEARCH', data)
	}


}





export default {
	actions,
	mutations,
	state,
	getters
}